export default "__VITE_ASSET__CBcRocyt__"